import * as React from 'react';
import classnames from 'classnames';
import { debounce } from 'throttle-debounce';
import { MediaQuery, CheckboxList } from '@grandvisionhq/common';
import { ConfiguratorStepTitleAndDescription, ConnectedStepForm } from '@grandvisionhq/configurator';
import { Util, Date } from '@grandvisionhq/forms';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../../context/RxGlassesConfiguratorContext.js';
import DesktopStepLayout from '../components/DesktopStepLayout/DesktopStepLayout.js';
import { RxStepWrapper } from '../components/RxStepWrapper/RxStepWrapper.js';

const PrescriptionStepValidationStep = ({ className , prescriptionInfoFormState , showValidationError , verificationAllowed , onVerificationAllowedChange , onChange , onSubmit ,  })=>{
    const { getLabel  } = useIntl();
    const isDesktop = MediaQuery.useIsDesktop();
    const { isYearInRange  } = Util.validations;
    const verificationCheckbox = React.useMemo(()=>({
            label: getLabel('products.glasses.validationStep.verificationAllowed.checkbox'),
            value: 'verificationAllowed'
        })
    , [
        getLabel
    ]);
    const handleFormChange = React.useCallback(debounce(250, (state)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(state.formState);
    }), [
        onChange
    ]);
    const handleConsentChange = React.useCallback((selectedItems)=>{
        onVerificationAllowedChange === null || onVerificationAllowedChange === void 0 ? void 0 : onVerificationAllowedChange(!!selectedItems.includes(verificationCheckbox));
    }, [
        onVerificationAllowedChange
    ]);
    const { opticianForm  } = useRxGlassesConfiguratorContext();
    const expiryDateErrorMessage = getLabel('products.glasses.validationStep.expiryDate.errorMessage');
    const expiryDateFieldLabels = {
        expiryDateDay: getLabel('common.placeholder.day.abbr'),
        expiryDateMonth: getLabel('common.placeholder.month.abbr'),
        expiryDateYear: getLabel('common.placeholder.year.abbr')
    };
    const isDesignV2 = true;
    const Wrapper = DesktopStepLayout ;
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('prescription-validation-step', className),
        "data-t": "prescription-validation-step"
    }, /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop && isDesignV2 ? 'left' : 'center'
    }), showValidationError && /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        title: getLabel('products.glasses.validationStep.form.validationError'),
        className: "alert-m-default prescription-validation-step__alert"
    }), /*#__PURE__*/ React.createElement(ConnectedStepForm, {
        className: "prescription-validation-step__form",
        initialFormState: prescriptionInfoFormState,
        onChange: handleFormChange,
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement(Date, {
        tooltipText: getLabel('products.glasses.validationStep.expiryDate.tooltip'),
        label: getLabel('products.glasses.validationStep.expiryDate'),
        name: "expiryDate",
        "data-t": "expiry-date",
        invalidDateErrorMessage: expiryDateErrorMessage,
        fieldLabels: expiryDateFieldLabels,
        required: true,
        validations: [
            {
                validator: isYearInRange(3),
                errorMessage: expiryDateErrorMessage
            }, 
        ]
    }), opticianForm && opticianForm(), /*#__PURE__*/ React.createElement(CheckboxList, {
        idPrefix: "prescription_validation__",
        items: [
            verificationCheckbox
        ],
        selectedItems: verificationAllowed ? [
            verificationCheckbox
        ] : [],
        onChange: handleConsentChange,
        getItemIdentifier: (item)=>item.value
        ,
        renderItem: (item)=>item.label
    }))));
};

export { PrescriptionStepValidationStep as default };
//# sourceMappingURL=PrescriptionValidationStep.js.map
